module.exports = __webpack_public_path__ + "images/base-plan-4e5a89e410aca17ba98deb1ccb09e19b.jpg";